export class FreightsCompanyRequest{
    id:number;
    name: string;
    code: string;
    linerAddress:string;
    isActive: boolean;
    createdAt : Date | any;
    createdUser : string;
    updatedAt : Date | any;
    updatedUser : string;
    versionFlag : number;
    constructor( 
        id:number,
        name: string,
        code: string,
        linerAddress:string,
        isActive: boolean,
        createdAt : Date | any,
        createdUser : string,
        updatedAt : Date | any,
        updatedUser : string,
        versionFlag : number,
        ){
        this.id = id,
        this.name = name,
        this.code = code,
        this.linerAddress = linerAddress,
        this.isActive = isActive,
        this.createdAt  = createdAt,
        this.createdUser  = createdUser,
        this.updatedAt  = updatedAt,
        this.updatedUser  = updatedUser,
        this.versionFlag  = versionFlag
        }

}

